module.exports = __webpack_public_path__ + "img/nogroupshare.ac43cc38.svg";